"use strict";

angular.module("core").component("orderDetails", {
    controllerAs: "orderDetailsCtrl",
    templateUrl: require("./order-details.component.html"),
    bindings: {
        order: "=",
        orderService: "<"
    },
    controller: function(
        $scope, $state, $stateParams, $rootScope, appConfig, gettextCatalog, FlashBag, ModalService,
        CoreOrderService, UserService, OrderStatusService, InvoiceService, ReadOnlyPermissionService,
        ORDER_STATUS, IS_MOBILE
    ) {
        var _this = this;
        $scope.isMobile = IS_MOBILE;
        $scope.canModifyOrder = false;
        $scope.isCanModifyOrderDisabled = false;
        $scope.canCancelOrder = false;
        $scope.orderService = this.orderService;
        $scope.previousState = $rootScope.fromState.name;
        $scope.previousParams = $rootScope.fromParams;
        $scope.orderId = $stateParams.id;

        if ($scope.previousState === "") {
            $scope.previousState = "home";
            $scope.previousParams = null;
        }

        $scope.statusNamesLocalized = OrderStatusService.getStatusNamesTranslations();
        $scope.otherChargesLocalized = CoreOrderService.getOtherChargesLocalized();
        $scope.taxesLocalized = CoreOrderService.getTaxesLocalized();

        CoreOrderService.get($scope.orderId).then(function onSuccess(response) {
            $scope.order = response.data;
            _this.order = $scope.order;
            var isOrderValid = (
                $scope.order.latest_related_revision === null
                && (
                    $scope.order.status === ORDER_STATUS.TRANSMITTED
                    || $scope.order.status === ORDER_STATUS.MODIFIED
                )
            );
            UserService.isUserFetched().then(function onSuccess(user) {
                if (user) {
                    $scope.dedicatedVendorId = user.dedicated_vendor_id;
                    $scope.isVendorOrderManager = (
                        !!$scope.dedicatedVendorId && user.dedicated_user_vendor
                        && user.dedicated_user_vendor.type === 'vendor_order_manager'
                    );
                    $scope.canModifyOrder = (
                        (
                            (
                                user.vendor && user.vendor.allow_order_modification
                            ) || (
                                user.dedicated_user_vendor
                                && user.dedicated_user_vendor.allow_order_modification
                                && $scope.order && $scope.order.allow_order_modification
                                && !!$scope.dedicatedVendorId
                            )
                        )
                        && $scope.order.latest_related_revision === null
                        && $scope.order.status !== ORDER_STATUS.INVOICED
                    );
                    $scope.isCanModifyOrderDisabled = $scope.order.status === ORDER_STATUS.CANCELLED;
                    $scope.canInvoice = (
                        (appConfig.APP === 'customer' && user.info.can_invoice && !!$scope.dedicatedVendorId)
                        || (appConfig.APP === 'vendor' && user.info.can_invoice)
                    ) && isOrderValid;
                    $scope.canCancelOrder = (
                        appConfig.APP === 'customer' && $scope.canModifyOrder
                        && !$scope.isVendorOrderManager && isOrderValid
                        && user.dedicated_user_vendor && user.dedicated_user_vendor.allow_order_cancellation
                    );
                }
            });
        });

        this.startOrderModification = function() {
            if (!$scope.canModifyOrder || $scope.isCanModifyOrderDisabled) {
                return;
            }

            $scope.orderService.startOrderModification($scope.orderId);
        };

        this.cancelOrder = function() {
            if (!$scope.canCancelOrder) {
                return;
            }

            $scope.orderService.cancelOrder($scope.orderId);
        };

        this.createInvoice = function() {
            if (!$scope.canInvoice) {
                return;
            }

            // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
            ModalService.showModal({
                templateUrl: require("core/confirmation/confirmation.modal.html"),
                controller: "Confirmation",
                controllerAs: "ConfirmationCtrl",
                inputs: {
                    $attrs: {
                        title: gettextCatalog.getString("Order Creation Confirmation"),
                        message: gettextCatalog.getString("Do you want to create an invoice with this order?")
                    }
                }
            }).then(function onSuccess(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function onSuccess(result) {
                    if (!result) {
                        return;
                    }

                    InvoiceService.create({
                        order: $scope.orderId
                    }).then(function onSuccess(invoice) {
                        FlashBag.success(gettextCatalog.getString("Invoice was created successfully."), true);
                        $state.go('invoiceDetails', {id: invoice.id});
                    }, function onError(response) {
                        if (appConfig.APP === 'customer') {
                            if (response.data && response.data.order && response.data.order.uom_validation_required) {
                                openOrderUoMValidationErrorModal(response.data.order.uom_validation_required);
                            }
                            else {
                                ReadOnlyPermissionService.handleResponseError(response);
                                FlashBag.apiError(response);
                            }
                        }
                        else {
                            FlashBag.apiError(response);
                        }
                    });
                });
            });
        };

        function openOrderUoMValidationErrorModal(message) {
            // noinspection JSCheckFunctionSignatures,JSVoidFunctionReturnValueUsed
            ModalService.showModal({
                templateUrl: require("core/confirmation/confirmation.modal.html"),
                controller: "Confirmation",
                controllerAs: "ConfirmationCtrl",
                inputs: {
                    $attrs: {
                        title: gettextCatalog.getString("Order validation required"),
                        message: message,
                        confirmTextButton: gettextCatalog.getString("Modify Order")
                    }
                }
            }).then(function onSuccess(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function onSuccess(result) {
                    if (!result) {
                        return;
                    }
                    _this.startOrderModification();
                });
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/order/order-details.component.js
// module id = 523
// module chunks = 0